var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 2.49951C14.1361 2.49951 17.5006 5.86396 17.5006 10.0001C17.5006 14.1362 14.1361 17.5007 9.99998 17.5007C5.86384 17.5007 2.49939 14.1362 2.49939 10.0001C2.49939 5.86396 5.86384 2.49951 9.99998 2.49951ZM9.99998 1.37451C5.2363 1.37451 1.37439 5.23643 1.37439 10.0001C1.37439 14.7638 5.2363 18.6257 9.99998 18.6257C14.7636 18.6257 18.6256 14.7638 18.6256 10.0001C18.6256 5.23643 14.7636 1.37451 9.99998 1.37451Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 5.87451C8.875 6.17288 8.99353 6.45903 9.20451 6.67001C9.41548 6.88099 9.70163 6.99951 10 6.99951C10.2984 6.99951 10.5845 6.88099 10.7955 6.67001C11.0065 6.45903 11.125 6.17288 11.125 5.87451C11.125 5.57614 11.0065 5.28999 10.7955 5.07902C10.5845 4.86804 10.2984 4.74951 10 4.74951C9.70163 4.74951 9.41548 4.86804 9.20451 5.07902C8.99353 5.28999 8.875 5.57614 8.875 5.87451Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.2505C9.37949 15.2505 8.875 14.746 8.875 14.1255V9.62549C8.875 9.00498 9.37949 8.50049 10 8.50049C10.6205 8.50049 11.125 9.00498 11.125 9.62549V14.1255C11.125 14.746 10.6205 15.2505 10 15.2505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.028430e20caed4cb58d5101e2aefbedf.svg";
export { ForwardRef as ReactComponent };